import request from '@/libs/request'
// 登录
export function cardList (data) {
  return request({
    url: `card/list`,
    method: 'get',
    params: data
  })
}

// 详情
export function cardInfo (data) {
  return request({
    url: `card/info`,
    method: 'get',
    params: data
  })
}

// 添加
export function cardEdit(data) {
  return request({
    url: `card/edit`,
    method: 'post',
    data: data
  })
}
